
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rollers/blinds/[slug]",
      function () {
        return require("private-next-pages/rollers/blinds/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rollers/blinds/[slug]"])
      });
    }
  